import React, { Suspense, useContext, useEffect } from "react";
import { HashRouter, Route, Routes, useNavigate } from "react-router-dom";

import { CSpinner, useColorModes } from "@coreui/react";
import "./scss/style.scss";
import "./App.css";
import "./components/admin/Tabels/Tabels.css"
import "./common/common_css/Form_Css.css"
import "./common/common_css/Common_Css.css"

// We use those styles to show code examples, you should remove them in your application.
import "./scss/examples.scss";
import { useDispatch, useSelector } from "react-redux";
import { AuthLogOut, GETAuthLogin } from "./features/auth/Slice";
import { Context } from "./utils/context";
import Reset_Password from "./components/login/Reset_Password";
import Set_New_Password from "./components/login/Set_New_Password";
import { RecieveMessage } from "./features/admin/whatsapp/message/slice";
// import ProductForm from "./components/admin/productmanagement/product/CommonForm";
// import ProductForm from "./components/admin/productmanagement/product/CommonForm";

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./components/login/Login"));
// const Register = React.lazy(() => import("./views/pages/register/Register"));
const Page404 = React.lazy(() => import("./components/page404/Page404"));
const Page500 = React.lazy(() => import("./components/page500/Page500"));

const App = () => {
  const { isSidebarOpen, isAllow, signin } = useContext(Context);
  const { isColorModeSet, setColorMode } = useColorModes(
    "coreui-free-react-admin-template-theme"
  );
  const settings = useSelector((state) => state.settings);

  useEffect(() => {
    if (settings.theme) {
      setColorMode(settings.theme);
    }

    if (isColorModeSet()) {
      return;
    }

    setColorMode(settings.theme);
  }, []);

  // Auth Management
  // const auth = useSelector((state) => state.auth);
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getAuth = async () => {
    try {
      const res = await dispatch(GETAuthLogin());

      if (!res.payload.success) {
        await dispatch(AuthLogOut());
        navigate("/");
      }

      await dispatch(RecieveMessage())
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAuth();
  }, [dispatch]);

  // useEffect(() => {
  //   if (auth.isLogin) {
  //     navigate("/dashboard");
  //   } else {
  //     navigate("/");
  //   }
  // }, [auth]);

  return (
    // <HashRouter>
    <Suspense
      fallback={
        <div className="pt-3 text-center">
          <CSpinner color="primary" variant="grow" />
        </div>
      }
    >
      {/* {!signin ? ( */}
      {/* <Login /> */}
      {/* <Route exact path="/" name="Login Page" element={<Login />} /> */}
      {/* ) : ( */}
      <Routes>
        <Route exact path="/" name="Login Page" element={<Login />} />
        <Route exact path="/reset-password" name="Reset_Password" element={<Reset_Password />} />
        <Route exact path="/set-new-password" name="set_new_password" element={<Set_New_Password />} />
        {/* <Route
            exact
            path="/register"
            name="Register Page"
            element={<Register />}
          />*/}
        <Route exact path="/404" name="Page 404" element={<Page404 />} />
        <Route exact path="/500" name="Page 500" element={<Page500 />} />
        <Route exact path="/500" name="Page 500" element={<Page500 />} />
        <Route path="*" name="Home" element={<DefaultLayout />} />
        {/* <Route path="/product-management/create" name="create" element={<ProductForm text="List" />} />
        <Route path="/product-management/edit" name="Edit" element={<ProductForm text="Edit" />} /> */}
      </Routes>
      {/* )} */}
    </Suspense>
    // </HashRouter>
  );
};

export default App;
